export default "__VITE_ASSET__BA8JGLWW__"